import React from "react";
import { Button } from "_c/button";
import CameraIcon from "_c/icon/Camera";
import { useCloudinaryWidget } from "@/hooks/useCloudinaryWidget";
import TrashIcon from "_c/icon/Trash";

const PhotoUpload = ({ onChange, photo, t, ...props }) => {
  const { uploadPhoto } = useCloudinaryWidget();
  const onClick = async () => {
    if (photo) {
      onChange(null);
    } else {
      const newPhoto = await uploadPhoto();
      if (newPhoto) {
        onChange(newPhoto);
      }
    }
  };
  const photoLabel = t(`common:${photo ? "remove_photo" : "add_photo"}`);
  return (
    <>
      <Button
        onClick={onClick}
        {...props}
        type="button"
        small
        negative={Boolean(photo)}
        greenish={!Boolean(photo)}
        withIcon
        aria-label={photoLabel}
      >
        {photo ? (
          <TrashIcon width="20" color="white" />
        ) : (
          <CameraIcon width="20" color="white" />
        )}
        <span>{photoLabel}</span>
      </Button>
    </>
  );
};

export default PhotoUpload;
